export const YEAR_PRESETS = {
  scottish: ["1st Year", "2nd Year", "3rd Year", "4th Year", "5th Year", "6th Year"],
  english: ["Year 7", "Year 8", "Year 9", "Year 10", "Year 11", "Year 12", "Year 13"],
  college: ["Year 1", "Year 2", "Year 3", "Year 4"],
};

export const PRESET_LABELS = {
  scottish: "Scottish (1st–6th Year)",
  english: "English (Year 7–13)",
  college: "College / uni (Year 1–4)",
};

export const PRESET_LABELS_LONG = {
  scottish: "Scottish — 1st to 6th Year",
  english: "English — Year 7 to 13",
  college: "College / uni — Year 1 to 4",
};
